import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ModalService } from '@core/services/modal.service';
import { collectFormErrors, FormErrorEntry } from '@shared/helpers/form-errors-debug.helper';
import { INavbarLink } from '@shared/models/interfaces/navbar-link.interface';

export interface FormErrorRow extends FormErrorEntry {
    section: string;
}

@Injectable({ providedIn: 'root' })
export class FormErrorsDebugService {
    static readonly MODAL_ID = 'formErrorsDebug';

    private readonly _title$ = new BehaviorSubject<string>('');
    private readonly _entries$ = new BehaviorSubject<FormErrorRow[]>([]);
    readonly title$ = this._title$.asObservable();
    readonly entries$ = this._entries$.asObservable();

    constructor(private modalService: ModalService) {}

    /** Errori di un singolo form di sezione. */
    show(sectionTitle: string, form?: FormGroup): void {
        this._title$.next(sectionTitle);
        this._entries$.next(form ? collectFormErrors(form).map((entry) => ({ ...entry, section: sectionTitle })) : []);
        this.modalService.open(FormErrorsDebugService.MODAL_ID);
    }

    /** Resoconto aggregato degli errori di più sotto-sezioni (contenitori Ammin. e controllo / Scheda di settore). */
    showAggregate(containerTitle: string, subLinks: INavbarLink[]): void {
        this._title$.next(containerTitle);
        const entries = subLinks.flatMap((subLink) => (subLink.form ? collectFormErrors(subLink.form).map((entry) => ({ ...entry, section: subLink.title })) : []));
        this._entries$.next(entries);
        this.modalService.open(FormErrorsDebugService.MODAL_ID);
    }
}
